var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header",
    transform: "translate(-596.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(564.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(32.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "BG",
    fillOpacity: 0,
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: ".misc-/-Fill-/-Grey-5",
    mask: "url(#mask-2)",
    fill: "#F4F6FC"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", {
    id: "down-arrow",
    mask: "url(#mask-2)",
    fill: "#7450C8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 6.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4,7.2 C11.0686292,7.2 10.8,7.46862915 10.8,7.8 L10.8,10.2 C10.8,10.5313708 10.5313708,10.8 10.2,10.8 L1.8,10.8 C1.46862915,10.8 1.2,10.5313708 1.2,10.2 L1.2,7.8 C1.2,7.46862915 0.93137085,7.2 0.6,7.2 C0.26862915,7.2 0,7.46862915 0,7.8 L0,10.2 C0,11.1941125 0.80588745,12 1.8,12 L10.2,12 C11.1941125,12 12,11.1941125 12,10.2 L12,7.8 C12,7.46862915 11.7313708,7.2 11.4,7.2 Z M5.574,8.226 C5.63106223,8.28062438 5.69834921,8.32344337 5.772,8.352 C5.91722393,8.41618607 6.08277607,8.41618607 6.228,8.352 C6.30165079,8.32344337 6.36893777,8.28062438 6.426,8.226 L8.826,5.826 C9.0612733,5.5907267 9.06127329,5.20927331 8.82599999,4.97400001 C8.59072669,4.73872671 8.2092733,4.7387267 7.974,4.974 L6.6,6.354 L6.6,0.6 C6.6,0.26862915 6.33137085,0 6,0 C5.66862915,0 5.4,0.26862915 5.4,0.6 L5.4,6.354 L4.026,4.974 C3.87380486,4.82180485 3.65197561,4.76236588 3.44407317,4.81807316 C3.23617074,4.87378045 3.07378045,5.03617074 3.01807316,5.24407317 C2.96236588,5.45197561 3.02180485,5.67380486 3.174,5.826 L5.574,8.226 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.513d5a47d6b94d93f0f44d9044fd164a.svg";
export { ForwardRef as ReactComponent };